module.exports = __webpack_public_path__ + "static/scale-model-of-atlanta-audubon-society-in-sandy-springs-georgia-37c2d0f5e7185fec61abad7287546b34.png";